export function OrDivider({ label = 'or' }: { label?: string }) {
  return (
    <div className="flex items-center gap-3">
      <span className="h-px flex-1 bg-black/8" />
      <span className="text-[12px] font-semibold text-ink3">{label}</span>
      <span className="h-px flex-1 bg-black/8" />
    </div>
  );
}
